import * as React from 'react';
import { getCatalog } from '@/redux/modules/catalog';
import { getCatalogUrl } from '@/utils/urls';
import { getNextCatalogItemIds } from '@/redux/modules/filteredItems';
import isEqual from 'react-fast-compare';
import ItemShelfCatalog from '@/components/ItemShelfCatalog/ItemShelfCatalog';
import { useSelector } from 'react-redux';

type Props = {
    catalogId: number;
    className?: string;
    itemId: number;
};

const MoreCatalogItemsContainer = ({ catalogId, className, itemId }: Props) => {
    const { title } = useSelector((state) => getCatalog(state, catalogId), isEqual);
    const itemIds = useSelector((state) => getNextCatalogItemIds(state, catalogId, itemId, 20), isEqual);

    const catalogUrl = getCatalogUrl(catalogId, title);

    return (
        <ItemShelfCatalog
            catalogId={catalogId}
            className={className}
            cta={itemIds.length > 6}
            identifier="moreItemsFromCatalog"
            itemIds={itemIds}
            seeAllUrl={catalogUrl}
        />
    );
};

export default React.memo<Props>(MoreCatalogItemsContainer);
